import type { UIStrings } from './en';

export const ar: UIStrings = {
  'site.title': 'DopeJs — أدوات مفتوحة المصدر للتطوير مع الوكلاء',
  'site.description':
    'يبني DopeJs أدوات مفتوحة المصدر للتطوير في زمن الذكاء الاصطناعي: بيئات تشغيل للوكلاء، ووكلاء برمجة في الطرفية، وأدوات لإدارة بيئات الـ CLI، ومحركات عرض Canvas.',

  'nav.projects': 'المشاريع',
  'nav.about': 'حول',
  'nav.github': 'GitHub',
  'nav.skip': 'تخطَّ إلى المحتوى',
  'nav.theme': 'المظهر',
  'nav.language': 'اللغة',

  'hero.eyebrow': 'مفتوح المصدر · يُطوَّر علنًا',
  'hero.title': 'أدوات للتطوير مع الذكاء الاصطناعي.',
  'hero.body':
    'DopeJs مجموعة صغيرة من المشاريع مفتوحة المصدر تدور حول سؤال واحد: كيف تبدو البرمجيات التي تستخدمها يوميًا عندما تصبح الوكلاء جزءًا من دورة العمل؟ بيئات تشغيل للوكلاء، ووكلاء برمجة في الطرفية، وأدوات لبيئات الـ CLI، ومحركات عرض Canvas — كلها تُطوَّر علنًا.',
  'hero.cta.projects': 'تصفَّح المشاريع',
  'hero.cta.github': 'اعرضه على GitHub',
  'hero.count': 'مشاريع',

  'projects.title': 'المشاريع',
  'projects.repo': 'المستودع',
  'projects.homepage': 'الموقع',
  'projects.install': 'التثبيت',
  'projects.copy': 'نسخ',
  'projects.copied': 'تم النسخ',
  'projects.details': 'التفاصيل',

  'status.stable': 'صدر رسميًا',
  'status.active': 'تطوير نشط',
  'status.early': 'مرحلة مبكرة — غير جاهز للإنتاج',
  'status.design': 'مرحلة التصميم',

  'project.back': 'كل المشاريع',
  'project.overview': 'نظرة عامة',
  'project.highlights': 'ماذا يفعل',
  'project.getStarted': 'البدء',
  'project.requirements': 'المتطلبات',
  'project.facts': 'لمحة سريعة',
  'project.facts.status': 'الحالة',
  'project.facts.languages': 'اللغات',
  'project.facts.license': 'الترخيص',
  'project.facts.noLicense': 'لا يوجد بعد',
  'project.links': 'روابط',
  'project.issues': 'Issues',
  'project.releases': 'Releases',
  'project.prev': 'السابق',
  'project.next': 'التالي',

  'about.title': 'حول DopeJs',
  'about.body':
    'كل ما هنا يُطوَّر علنًا على GitHub. نرحّب بالـ issues وطلبات الدمج في أي مستودع — ونرحّب بالقدر نفسه بالتقارير الصريحة عن أشياء لا تعمل بعد. بعض هذه المشاريع في مرحلة ما قبل الإصدار عن قصد، وحين يكون الأمر كذلك يذكره المشروع صراحةً.',
  'about.cta': 'تابع المنظمة على GitHub',

  'footer.built': 'مبني باستخدام React و Vite. الشيفرة على GitHub.',
  'footer.rights': 'DopeJs',
  'footer.translations': 'الترجمات مُولَّدة آليًا — التصحيحات مرحَّب بها.',
};
